import PropertyItemTypeEnum from "../PropertyItemTypeEnum";
import PropertyTranslator from "../PropertyTranslator";
import { mmFromSceneUnits, sceneUnitsFromMm } from "../../../utils/scaler";

const MM_PER_CM = 10;

// Value is stored in scene units (see utils/scaler.ts) but edited/displayed in cm.
const lengthCmTranslator: PropertyTranslator<number> = {
    getItemType: () => PropertyItemTypeEnum.Length,

    getDisplayValue: (value) => {
        const cm = mmFromSceneUnits(value) / MM_PER_CM;
        return String(Math.round(cm * 100) / 100);
    },

    setValue: (displayText) => {
        const cm = Number(displayText.trim().replace(',', '.'));
        if (!Number.isFinite(cm) || cm <= 0) return { ok: false };

        return { ok: true, value: sceneUnitsFromMm(cm * MM_PER_CM) };
    },

    isEqual: (a, b) => Math.abs(a - b) < 1e-9,

    getListType: () => 'none',

    usesButton: () => false,

    refreshOnEdit: () => true,
};

export default lengthCmTranslator;
